/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthNoteAction = {
    Added: 'added',
    Edited: 'edited',
    Removed: 'removed',
} as const;
export type PalReauthNoteAction = typeof PalReauthNoteAction[keyof typeof PalReauthNoteAction];


export function instanceOfPalReauthNoteAction(value: any): boolean {
    for (const key in PalReauthNoteAction) {
        if (Object.prototype.hasOwnProperty.call(PalReauthNoteAction, key)) {
            if (PalReauthNoteAction[key as keyof typeof PalReauthNoteAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PalReauthNoteActionFromJSON(json: any): PalReauthNoteAction {
    return PalReauthNoteActionFromJSONTyped(json, false);
}

export function PalReauthNoteActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthNoteAction {
    return json as PalReauthNoteAction;
}

export function PalReauthNoteActionToJSON(value?: PalReauthNoteAction | null): any {
    return value as any;
}

export function PalReauthNoteActionToJSONTyped(value: any, ignoreDiscriminator: boolean): PalReauthNoteAction {
    return value as PalReauthNoteAction;
}

